module.exports = "../../microservices-architecture.JPG";